/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "wrapper_colors_default": "",
  "wrapper_size_default": "min-h-[320px] sm:min-h-[240px] pb-3 box-content",
  "wrapper_variant_default": "overflow-visible flex justify-center items-start",
  "placement_colors_default": "",
  "placement_size_default": "w-full h-full md:p-0",
  "placement_variant_default": "flex justify-center items-start",
  "size_default": "text-xs leading-6.5 w-full z-10 my-6",
  "colors_default": "wings wings-gray-200 bg-gray-200",
  "variant_default": "font-sans relative text-center"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Adunit");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;